import { Type } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { UsageTrackingServiceInterface } from '../models/usage-tracking-service.interface';
import { CustomChartFilterService } from '../services/custom-chart-filter.service';
import { DashboardNavigationTrackingService } from '../services/dashboard-navigation-tracking.service';
import { HighlightTrackingService } from '../services/highlight-tracking.service';
import { LandingNavigationTrackingService } from '../services/landing-navigation-tracking.service';
import { ShareTrackingService } from '../services/share-tracking.service';
import { SidenavButtonsTrackingService } from '../services/sidenav-buttons-tracking.service';
import { SidenavFilterService } from '../services/sidenav-filter.service';
import { ACTION_TYPES } from '../usage-tracking.config';

const ACTION_TYPE_SERVICES: Record<
  string,
  Type<UsageTrackingServiceInterface>
> = {
  [ACTION_TYPES.dashboardNavigation]: DashboardNavigationTrackingService,
  [ACTION_TYPES.landingNavigation]: LandingNavigationTrackingService,
  [ACTION_TYPES.share]: ShareTrackingService,
  [ACTION_TYPES.filterClickedOnChart]: CustomChartFilterService,
  [ACTION_TYPES.filterClickedOnSidenav]: SidenavFilterService,
  [ACTION_TYPES.highlight]: HighlightTrackingService,
  [ACTION_TYPES.filtersButtonClicked]: SidenavButtonsTrackingService,
  [ACTION_TYPES.areasButtonClicked]: SidenavButtonsTrackingService,
  [ACTION_TYPES.menuButtonClicked]: SidenavButtonsTrackingService,
  [ACTION_TYPES.homeButtonClicked]: SidenavButtonsTrackingService,
  [ACTION_TYPES.goBackButtonClicked]: SidenavButtonsTrackingService,
  [ACTION_TYPES.showKpisButtonClicked]: SidenavButtonsTrackingService,
  [ACTION_TYPES.dashboardsButtonClicked]: SidenavButtonsTrackingService,
  [ACTION_TYPES.refreshButtonClicked]: SidenavButtonsTrackingService,
  [ACTION_TYPES.logoutButtonClicked]: SidenavButtonsTrackingService,
  [ACTION_TYPES.adminButtonClicked]: SidenavButtonsTrackingService,
  [ACTION_TYPES.switchThemeButtonClicked]: SidenavButtonsTrackingService,
  [ACTION_TYPES.activateMicrophoneButtonClicked]: SidenavButtonsTrackingService,
  [ACTION_TYPES.deactivateMicrophoneButtonClicked]:
    SidenavButtonsTrackingService,
  [ACTION_TYPES.highlightButtonClicked]: SidenavButtonsTrackingService,
  [ACTION_TYPES.settingsButtonClicked]: SidenavButtonsTrackingService,
  [ACTION_TYPES.togglePanel]: SidenavButtonsTrackingService,
};

export class UsageTrackingFactory {
  public static createTrackingService(
    actionType: string
  ): UsageTrackingServiceInterface {
    const serviceType = ACTION_TYPE_SERVICES[actionType];
    return serviceType && SharedModule.injector.get(serviceType);
  }
}
